<!-- 订舱-文件历史 -->
<template>
  <div>
    <div class="section operations">
      <div v-show="cooperateEdit" class="triggers">
        <div>
          <el-button no="Refresh" :disabled="controlledLocked" type="primary" @click="toQuery">{{ $t('FileHistory.Refresh') }}</el-button>
          <el-button v-permission="['button_FileHistory_fileUpload']" no="fileUpload" :disabled="controlledLocked" type="primary" @click="showCloudFile()">{{ $t('FileHistory.Upload') }}</el-button>
          <el-button v-permission="['button_FileHistory_fileDelete', 'role_FileDownloads_ownFileDelete']" no="fileDelete" :disabled="!showButton || deleteBtn || controlledLocked" type="danger" @click="remove">{{ $t('FileHistory.Delete') }}</el-button>
          <el-button no="download" :disabled="controlledLocked" type="primary" @click="download">{{ $t('FileHistory.BatchDownload') }}</el-button>
          <el-button v-if="!isAssemblyPlan" no="sendEmail" :disabled="controlledLocked" type="primary" @click="sendEmail">{{ $t('FileHistory.SendEmail') }}</el-button>
          <template v-if="viewSource === 'SeBooking' && job.masterFlag && oneClickSendDestinationPortAgent">
            <el-button v-if="job.sentDestinationPortAgent" disabled no="SentDestinationPortAgent" type="primary">{{ $t('FileHistory.SentDestinationPortAgent') }}</el-button>
            <el-button v-if="!job.sentDestinationPortAgent" no="SendDestinationPortAgent" type="primary" @click="sendDestinationPortAgent('16')">{{ $t('FileHistory.SendDestinationPortAgent') }}</el-button>
            <el-button v-if="showSendPackageProxyFilesButton" no="SendPackageProxyFiles" type="primary" @click="sendPackageAgent()">{{ $t('FileHistory.SendSetOfProxyOrders') }}</el-button>
            <el-button v-permission="['role_FileHistory_resetOneClickSend']" no="resetOneClickSend" type="primary" @click="resetOneClickSend()">{{ $t('FileHistory.ResetOneClickSend') }}</el-button>
          </template>
          <!-- 指令操作按钮 -->
          <template v-for="(item, index) in remainInstructions">
            <el-button
              v-if="item.platformInstructionRuleCode === LCL_RESET_ONE_CLICK_SEND.code"
              :key="index"
              v-permission="['role_FileHistory_resetOneClickSend']"
              :no="item.platformInstructionRuleCode"
              type="primary"
              :disabled="!item.allowOperate"
              @click="onInstructionClick(item)"
            >
              {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
            </el-button>
            <el-button
              v-else
              :key="index"
              :no="item.platformInstructionRuleCode"
              type="primary"
              :disabled="!item.allowOperate"
              @click="onInstructionClick(item)"
            >
              {{ $selectByLang(item.chineseName, item.englishName, item.japaneseName) }}
            </el-button>
          </template>
          <el-button v-if="ingotUploadButton" no="ingotUpload" type="primary" @click="ingotUpload">{{ $t('FileHistory.ingotUpload') }}</el-button>
          <el-button v-if="ingotButton" no="ingotLog" type="primary" @click="ingotLog">{{ $t('FileHistory.ingotLog') }}</el-button>
          <el-button v-if="showSyncButton" no="synchronization" :disabled="disabeSyncButton || syncBtn || controlledLocked" type="primary" @click="synchronizationFile">{{ $t('FileHistory.synchronization') }}</el-button>
          <el-button v-if="showSyncButton" no="cancelSynchronization" :disabled="disabeSyncButton || cancelBtn || controlledLocked" type="primary" @click="cancelSynchronization">{{ $t('FileHistory.cancelSynchronization') }}</el-button>
          <el-button
            v-if="uploadFileInstruction"
            :no="uploadFileInstruction.platformInstructionRuleCode"
            type="primary"
            :disabled="!uploadFileInstruction.allowOperate"
            @click="onInstructionClick(uploadFileInstruction)"
          >
            {{ $selectByLang(uploadFileInstruction.chineseName, uploadFileInstruction.englishName, uploadFileInstruction.japaneseName) }}
          </el-button>
          <el-button v-if="toExoSystemOC" no="showPushResultLog" type="primary" @click="pushResultLogDialog.visible = true">{{ $t('CargoMsg.Cargo_PushResultLog') }}</el-button>
          <el-checkbox v-if="job.masterFlag" v-model="showSlaveFile" style="margin-left: 15px;" @change="showSlaveFileChange">{{ $t('FileHistory.DisplayTicketFile') }}</el-checkbox>
        </div>
      </div>
    </div>
    <div class="section" style="flex: 1">
      <cargo-ag-grid
        config-module="136235"
        :grid-options="gridOptions"
        :grid-params.sync="gridParams"
        :column-defs="columnDefs"
        :row-data="rowData"
        :check-sub-record="false"
        style="width:100%;flex:1;padding:10px;"
        @gridReady="params=>gridApi=params.api"
      />
    </div>

    <drop-uploader v-if="canOperateJob" :auto-upload="dropAutoUpload" :action="URL.common.uploadStorage" :upload-params="uploadParams" @upload-end="uploadEnd" @choose-file="showCloudFile" />
    <!-- 文件类型选择对话框 -->
    <mx-file-type-editor
      v-if="fileTypeEditor.visible"
      :visible.sync="fileTypeEditor.visible"
      :lob="job.lob"
      :file-id="fileTypeEditor.fileId"
      :file-category="fileTypeEditor.fileCategory"
      :check-type-privilege="true"
      @saveFileType="data => {itemEditEndHandler(data);updateSopForFileType(data);}"
    />

    <!-- 云文件上传对话框 -->
    <cargo-cloud-file-upload
      :visible.sync="cloudFile.visible"
      :job="cloudFile.job"
      :upload-source="uploadSource"
      :lob="cloudFile.job.lob"
      :new-file="cloudFile.newFile"
      @uploadDone="data => {updateSop(data);sendFileOC();}"
    />
    <el-dialog
      v-if="isShowingDetailForm"
      v-el-drag-dialog
      no="DetailTitle"
      :close-on-click-modal="false"
      :visible.sync="isShowingDetailForm"
      :title="showDetailTitle"
      width="450px"
      append-to-body
    >
      <cargo-ag-grid
        :grid-options="gridOptionsFileDetail"
        :column-defs="columnDefsFileDetail"
        :row-data="rowDataFileDetail"
        style="width:400px;height: 300px"
        @gridReady="params=>gridApiFileDetail=params.api"
      />
    </el-dialog>

    <!-- 发送邮件弹窗 -->
    <send-email-dialog
      v-if="sendEmailDialog.visible"
      ref="sendEmailDialog"
      :visible.sync="sendEmailDialog.visible"
      :context="context"
      :job="job"
      :job-uuid-list="sendEmailDialog.jobUuidList"
      :source="source"
      :push-link="SystemConstants.FILE_HISTORY"
      :send-email-data="sendEmailDialog"
      :view-source="viewSource"
      append-to-body
    />

    <!--ingot日志-->
    <el-dialog
      v-el-drag-dialog
      no="ingotLog"
      :close-on-click-modal="false"
      :visible.sync="ingot.visible"
      :title="$t('FileHistory.ingotLog')"
      width="600px;"
      height="400px;"
      append-to-body
      @close="ingotClose"
    >
      <cargo-ag-grid
        :grid-options="ingot.gridOptions"
        :grid-params.sync="ingot.gridParams"
        :column-defs="ingot.columnDefs"
        :row-data="ingot.rowData"
        style="width:100%;height:350px;"
        @gridReady="params=>ingot.gridApi=params.api"
      />
    </el-dialog>
    <!-- 预览文件弹窗 -->
    <pre-view-file-dialog
      :v-if="previewFileData.visible"
      no="preview"
      :title="$t('FileHistory.preview')"
      :visible="previewFileData.visible"
      :file="previewFileData.file"
      :can-maximize="true"
      @close="closePreviewDialog"
    />
    <!-- 数据推送结果记录 -->
    <push-result-log-dialog v-if="pushResultLogDialog.visible" :visible.sync="pushResultLogDialog.visible" :job-uuid="job.uuid || ''" :job-keys="pushResultLogDialog.jobKeys" log-source="file" />
    <!-- 发送目的港代理邮件校验弹窗 -->
    <checking-send-destination-agent-window
      v-if="checkingWindow.visible"
      :visible.sync="checkingWindow.visible"
      :is-pass="checkingWindow.isPass"
      :master-info="checkingWindow.masterInfo"
      :slave-info="checkingWindow.slaveInfo"
      :row-data="checkingWindow.rowData"
      :show-next="checkingWindow.showNext"
      :match-instruction-tip="checkingWindow.matchInstructionTip"
      @next="sendDestinationPortAgentNext"
    />
    <!-- 发送目的港代理邮件弹窗 -->
    <send-destination-port-agent-email-dialog
      v-if="sendDestinationPortAgentEmailDialog.visible"
      :visible.sync="sendDestinationPortAgentEmailDialog.visible"
      :job="job"
      :file-list="sendDestinationPortAgentEmailDialog.fileList"
      :push-link="sendDestinationPortAgentEmailDialog.pushLink"
      :mail-template-uuid="sendDestinationPortAgentEmailDialog.mailTemplateUuid"
      :exchange-agent-data="sendDestinationPortAgentEmailDialog.exchangeAgentData"
      :file-type-of-take-multi="sendDestinationPortAgentEmailDialog.fileTypeOfTakeMulti"
      :mail-template-interface-type="sendDestinationPortAgentEmailDialog.mailTemplateInterfaceType"
      @callback="sendDestinationPortAgentCallback"
      @instructionCallback="data => instructionCallback(Object.assign({ instructionUuid: checkingWindow.instructionUuid }, data))"
    />
    <!-- 换单代理选择弹窗 -->
    <exchange-agent-select-dialog
      :visible.sync="exchangeAgentSelectDialog.visible"
      :job-uuid="exchangeAgentSelectDialog.jobUuid"
      :exchange-agents="exchangeAgentSelectDialog.exchangeAgents"
      @callback="onSelectExchangeAgent"
    />
    <!-- 一键发送窗口(用于指令处理) -->
    <one-click-send-window ref="oneClickSendWindow" :file-type-caps-map="fileTypeCapsMap" @writebackJob="onWritebackJob" @instructionCallback="onInstructionCallback" />
    <!-- 上传文件(用于指令处理) -->
    <upload-file-window ref="uploadFileWindow" @instructionCallback="onInstructionCallback" />
  </div>
</template>

<script>

import cargoCloudFileUpload from '@/components/Cargo/Common/cargoCloudFileUpload'
import URL from '@/api/urlTranslator'
import {
  getFileListByMultiParam,
  deleteFile,
  saveMetaData,
  synchronizationFileByJobs,
  cancelSynchronizationByJobs
} from '@/api/storage'
import { refreshPrintStatus, updateTrackingForDocumentType } from '@/api/fileHistory'
import { cacheName, cache } from '@/utils/cacheManager'
import { Job } from '@/class/model/booking/Job'
import { DocumentCategory } from '@/class/model/sys/DocumentCategory'
import { DocumentManage } from '@/utils/commonUtil'
import sendEmailDialog from '@/components/Cargo/Job/sendEmailDialog'
import SendDestinationPortAgentEmailDialog from '@/components/Cargo/Job/SendDestinationPortAgentEmailDialog'
import ColumnUtils from '@/utils/ColumnUtils'
import { TYPE_NAMES } from '@/utils/class/AdvanceSelect'
import { sortByMultiField } from '@/utils'
import MxFileTypeEditor from '@/components/Cargo/Job/mxFileTypeEditor'
import * as IngotType from '@/class/cargo/model/parameters/IngotType'
import DropUploader from '@/components/Cargo/Common/DropUploader'
import CargoDialog from '@/components/Cargo/Common/CargoDialog'
import { ingotUploadByJobs, queryIngotUploadListByJobs } from '@/api/seaExport/file'
import * as SystemConstants from '@/class/cargo/model/parameters/SystemConstants'
import { getLoading, getLoading4Cxt } from '@/utils/utilBaseElement'
import StrUtils from '@/utils/StrUtils'
import { sendFileByJobKeys, getOcFileListByJobKeys, batchDeletedByFileId } from '@/api/seaExport/seaExportJob'
import pushResultLogDialog from '@/components/Cargo/Job/pushResultLogDialog'
import * as FileType from '@/class/cargo/model/parameters/FileType'
import { WarehouseIn } from '@/class/model/booking/WarehouseIn'
import { FbaJob } from '@/class/model/booking/FbaJob'
import * as ChargeItemTarget from '@/class/cargo/model/parameters/ChargeItemTarget'
import { resetOneClickSend } from '@/api/booking/job'
import { checkSendDestinationPortAgent, checkSendDestinationPortAgentMulti } from '@/api/sysManage/baseConfig/checkRuleConfig'
import * as CheckRuleConstants from '@/class/cargo/model/parameters/CheckRuleConstants'
import CheckingSendDestinationAgentWindow from '@/components/Cargo/Job/CheckingManager/CheckingSendDestinationAgentWindow'
import preViewFileDialog from '@/components/Cargo/Common/preViewFileCommonDialog'
import { CabinManagement } from '@/class/model/booking/CabinManagement'
import ExchangeAgentSelectDialog from '@/components/Cargo/Job/booking/tabs/ExchangeAgentSelectDialog'
import { JobUtils } from '@/class/cargo/model/utils/JobUtils'
import { syncJobFiles } from '@/api/storage'
import {
  LOG_AE_SEA_BOOKING_FILE_HISTORY, LOG_AI_SEA_BOOKING_FILE_HISTORY, LOG_RE_SEA_BOOKING_FILE_HISTORY,
  LOG_SE_SEA_BOOKING_FILE_HISTORY, LOG_SI_SEA_BOOKING_FILE_HISTORY, PLATFORM_INSTRUCTION_CODE_LCL_RESET_ONE_CLICK_SEND,
  PLATFORM_INSTRUCTION_CODE_UPLOAD_FILE
} from '@/class/cargo/model/parameters/SystemConstants'
import * as DocumentConstants from '@/class/cargo/model/parameters/DocumentConstants'
import * as UICustomConstants from '@/class/cargo/model/parameters/UICustomConstants'
import { UICustomUtil } from '@/class/cargo/model/utils/UICustomUtil'
import { getJobInstructions } from '@/api/sysManage/uiCustom'
import { generateInstructionRecord } from '@/api/sysManage/baseConfig/instruction'
import { AssemblyPlan } from '@/class/model/booking/AssemblyPlan'
import OneClickSendWindow from '@/components/Cargo/Job/instructionManager/oneClickSendWindow'
import uploadFileWindow from '@/components/Cargo/Job/instructionManager/uploadFileWindow'

export default {
  name: 'TabFileHistory',
  components: { MxFileTypeEditor, cargoCloudFileUpload, sendEmailDialog, SendDestinationPortAgentEmailDialog, DropUploader, CargoDialog, pushResultLogDialog, CheckingSendDestinationAgentWindow, preViewFileDialog, ExchangeAgentSelectDialog, OneClickSendWindow, uploadFileWindow },
  props: {
    context: {
      type: Object,
      required: true
    },
    showButton: {
      type: Boolean,
      default: true
    },
    isCrossTenantSeToSi: {
      type: Boolean,
      default: false
    },
    viewSource: { // 页面请求发起方
      type: String,
      required: false
    },
    btnInfo: {
      type: Object,
      required: false,
      default: null
    },
    cooperateEdit: { // 能否修改
      type: Boolean,
      default: true
    },
    previewFileMethod: {
      type: Function,
      default: null
    },
    canOperateJob: {
      type: Boolean,
      default: true
    },
    showInstruction: {
      type: Boolean,
      default: false
    },
    controlledLocked: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      URL,
      SystemConstants,
      LCL_RESET_ONE_CLICK_SEND: PLATFORM_INSTRUCTION_CODE_LCL_RESET_ONE_CLICK_SEND,
      UPLOAD_FILE: PLATFORM_INSTRUCTION_CODE_UPLOAD_FILE,
      uploadSource: 'fileHistory',
      source: '7',
      ingotButton: false,
      ingotUploadButton: false,
      user: {},
      sendEmailDialog: {
        visible: false,
        emailTitle: '',
        emailContent: '',
        detailCode: '',
        fileIdList: '',
        fileList: null,
        jobUuidList: null
      },
      deleteBtn: false,
      syncBtn: false,
      cancelBtn: false,
      ingot: {
        visible: false,
        gridOptions: {},
        gridParams: {},
        gridApi: {},
        rowData: [],
        columnDefs: [
          { headerName: this.$t('SeaExport.FileName'), field: 'fileName', width: 150,
            tooltip: (params) => {
              return params.data.fileName
            }
          },
          { headerName: this.$t('SeaExport.UploadType'), field: 'fileType', width: 120,
            cellRenderer: params => {
              return this.fileTypeLabelFunction(params.value)
            },
            tooltip: (params) => {
              return params.data.fileType
            }
          },
          { headerName: this.$t('Partners.UploadTime'), field: 'time', width: 150,
            tooltip: (params) => {
              return params.data.time
            }
          },
          { headerName: this.$t('CargoMsg.Cargo_CSR'), field: 'userName', width: 150,
            cellRenderer: (params) => {
              return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', params.value, 'chineseName')
            },
            tooltip: (params) => {
              return params.data.userName
            }
          },
          { headerName: this.$t('SeaExport.Status'), field: 'resultType', width: 80,
            tooltip: (params) => {
              return params.data.resultType
            }
          },
          { headerName: this.$t('SeaExport.ReturnInformation'), field: 'resultText', width: 200,
            tooltip: (params) => {
              return params.data.resultText
            }
          }
        ]
      },
      storageURL: '',
      fileTypeMap: new Map(),
      fileTypeCapsMap: new Map(), // 按照大写字母匹配
      docType: [],
      job: {},
      fileName: '',
      fileIdList: '',
      gridParams: {},
      gridOptions: {
        rowSelection: 'multiple',
        suppressCellSelection: true,
        context: {
          componentParent: this
        },
        // 选中 文件类型
        onCellFocused: (event) => {
          this.onFileTypeCellFocused(event)
        },
        treeData: true,
        getDataPath: data => {
          return (data.path || '').split(',')
        },
        autoGroupColumnDef: {
          headerName: this.$t('FileHistory.fileName'),
          field: 'fileName',
          width: 240,
          headerCheckboxSelection: true,
          headerCheckboxSelectionFilteredOnly: true,
          cellRendererParams: {
            suppressCount: true,
            suppressDoubleClickExpand: false,
            checkbox: params => {
              return true
            }
          }
        },
        onSelectionChanged: event => {
          const rows = event.api.getSelectedRows()
          let deleteBtn = false
          let syncBtn = false
          let cancelBtn = false
          for (const row of rows) {
            const { synchronizationState, sourceId, uuid } = row.extendMetaData
            if (!StrUtils.isEmpty(sourceId) || synchronizationState === '1' || (this.showSlaveFile && uuid !== this.job.uuid)) {
              deleteBtn = true
            }
            if (!StrUtils.isEmpty(sourceId) || synchronizationState === '1') {
              syncBtn = true
            }
            if (!StrUtils.isEmpty(sourceId) || !synchronizationState || synchronizationState === '0') {
              cancelBtn = true
            }
          }
          this.deleteBtn = deleteBtn
          this.syncBtn = syncBtn
          this.cancelBtn = cancelBtn
        }
      },
      columnDefs: [
        {
          headerName: this.$t('FileHistory.fileVersion'),
          field: 'fileVersion',
          width: 100
        },
        {
          headerName: this.$t('FileHistory.jobType'),
          field: 'fileType',
          width: 120,
          cellRenderer: params => {
            return this.fileTypeLabelFunction(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.fileType'),
          field: 'fileFormat',
          width: 120
        },
        {
          headerName: this.$t('FileHistory.fileSize'),
          field: 'fileSize',
          width: 120,
          cellRenderer: params => {
            return this.fileSizeColumnLabel(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.createdBy'),
          field: 'createdBy',
          width: 120,
          cellRenderer: (params) => {
            return ColumnUtils.resolveColumnLabel(TYPE_NAMES.basic_data_User, 'userId', parseInt(params.value), 'chineseName')
          }
        },
        {
          headerName: this.$t('FileHistory.createdDate'),
          field: 'createDate',
          width: 120
        },
        { headerName: this.$t('SeaExport.FileSource'),
          field: 'fileSource',
          width: 120,
          cellRenderer: params => {
            const fileSource = ChargeItemTarget.getChargeItemColumns(params.value)
            if (fileSource) {
              return this.isZh ? fileSource.chineseName : fileSource.code
            }
            return ''
          }
        },
        {
          headerName: this.$t('FileHistory.Details'),
          field: 'fileId',
          width: 120,
          cellRenderer: params => {
            const methodPath = this.documentManage.getPath('popFileHistoryDetailFormDialog')
            return `<a onclick="${methodPath}('${params.value}')" style="color:blue">${this.$t('FileHistory.Details')}</a>`
          }
        },
        {
          headerName: this.$t('FileHistory.operation'),
          field: 'fileId',
          width: 120,
          cellRenderer: params => {
            let preview = ''
            const fileStr = params.data.fileName
            const location = fileStr.lastIndexOf('.')
            if (JobUtils.canPreviewFile(fileStr.substring(location + 1, fileStr.length)) && !this.isAssemblyPlan) {
              const handlePreviewFile = this.documentManage.getPath('handlePreviewFile')
              preview = `<a onclick="${handlePreviewFile}('${params.value}')" style="color:blue">${this.$t('FileHistory.preview')}</a>`
            }

            const methodOnFileViewPath = this.documentManage.getPath('onFileView')
            return `<a onclick="${methodOnFileViewPath}('${params.value}')" style="color:blue">
                    ${this.$t('FileHistory.fileDownload')}
                    </a>` + preview
          }
          /* cellRenderer: params => {
            return `<a href="${this.storageURL}file/open/${params.value}?sessionId=${this.context.user.sessionId}" target="_blank" style="color:#46a6ff">{{$t('FileHistory.view')}}</a>`
          }*/
        },
        {
          headerName: this.$t('FileHistory.synchronizationState'),
          field: 'synchronizationState',
          colId: 'synchronizationState',
          hide: true,
          width: 120,
          cellRenderer: params => {
            if (params.value === '1') {
              return this.$t('Message.Synchronized')
            }
            return this.$t('Message.NotSynchronized')
          }
        },
        {
          headerName: this.$t('FileHistory.ExternalFileType'),
          field: 'externalFileType',
          width: 120,
          cellRenderer: (params) => {
            return this.externalFileTypeLabelFunc(params.value)
          }
        },
        {
          headerName: this.$t('FileHistory.LastSyncTime'),
          field: 'lastSyncTime',
          width: 140
        },
        {
          headerName: this.$t('queryJob.LastEmailSentTime'),
          field: 'lastEmailSentTime',
          width: 140,
          hide: true
        }
        // 文件预览代码撤回
        // {
        //   headerName: this.$t('FileHistory.preview'),
        //   field: 'fileId',
        //   width: 120,
        //   cellRendererFramework: OperationRender,
        //   cellRendererParams: {
        //     operations: [
        //       {
        //         title: this.$t('FileHistory.preview'),
        //         onClick: (params) => {
        //           this.handlePreviewFile(params)
        //         },
        //         visible: (params) => true,
        //         type: 'primary'
        //       }
        //     ]
        //   }
        // }
      ],
      rowData: [],
      gridApi: null,
      gridApiFileDetail: null,
      gridOptionsFileDetail: {
        context: {
          componentParent: this
        }
      },
      columnDefsFileDetail: [
        {
          headerName: this.$t('FileHistory.tagName'),
          field: 'key',
          width: 150
        },
        {
          headerName: this.$t('FileHistory.tagValue'),
          field: 'val',
          width: 200
        }
      ],
      rowDataFileDetail: [],
      defaultDocumentTypeCode: '', // 默认文件类型code
      defaultDocumentChineseName: '', // 默认文件类型中文名
      dropAutoUpload: true, // 拖拽文件后，是否自动上传
      cloudFile: {
        visible: false,
        job: new Job(),
        lob: 'SE',
        newFile: null
      },
      isShowingDetailForm: false,
      showDetailTitle: '',
      documentManage: new DocumentManage(),
      isAllowedEdit: true,
      fileTypeEditor: {
        visible: false,
        fileId: '',
        fileCategory: ''
      },
      previewFileData: {
        visible: false,
        file: null
      },
      officeFileUrl: '',
      toExoSystemOC: false, // 是否橙联推送
      crossDelegationSynchronizationField: false, // CARGO-30023 空运交叉委托增加基本页签数据
      oneClickSendDestinationPortAgent: false, // 是否启用一键发送目的港代理
      showSendPackageProxyFilesButton: false, // 是否显示【发送套单代理】按钮
      pushResultLogDialog: {
        visible: false,
        jobKeys: null
      },
      curRow: {}, // onshow传过来的原数据
      showSlaveFile: false, // 是否显示小票文件
      checkingWindow: {
        visible: false,
        isPass: false,
        masterInfo: '',
        slaveInfo: '',
        rowData: [],
        showNext: false,
        pushLink: '',
        mailTemplateUuid: '',
        instructionUuid: '',
        fileTypeOfTakeMulti: '',
        mailTemplateInterfaceType: 1
      },
      sendDestinationPortAgentEmailDialog: {
        visible: false,
        fileList: [],
        pushLink: '',
        mailTemplateUuid: '',
        mailTemplateInterfaceType: 1
      },
      exchangeAgentSelectDialog: {
        visible: false,
        jobUuid: '',
        exchangeAgents: [],
        selectData: null,
        instruction: {}
      },
      instructioinBtns: []
    }
  },
  computed: {
    crossDelegationSField() {
      return (['AE', 'SE', 'SI', 'IE'].includes(this.job.lob) && (this.job.trustFromJob || this.job.relatedJob) && this.crossDelegationSynchronizationField && this.job.jobState === 0)
    },
    showSyncButton() { // 同步 取消同步按钮 是否显示
      return (['SE', 'AE', 'SI', 'IE'].includes(this.job.lob) && this.btnInfo) || (['SI', 'AI'].includes(this.job.lob) && this.job.trustFromJob) || this.crossDelegationSField
    },
    disabeSyncButton() { // 同步 取消同步按钮 是否禁用
      return !(
        ((this.btnInfo && this.btnInfo.privilege.consignationEnableSI && this.$store.getters.isGroupCompany) && this.job.relatedJob) ||
        ((this.btnInfo && this.btnInfo.privilege.consignationEnableAI && this.$store.getters.isGroupCompany) && this.job.relatedJob) ||
        (['SI', 'AI'].includes(this.job.lob) && this.job.trustFromJob) || this.isCrossTenantSeToSi || this.crossDelegationSField)
    },
    isWarehouseIn() { // 是否国内仓国外仓
      return this.curRow && this.curRow.className && this.curRow.className === 'WarehouseIn'
    },
    isFbaJob() { // FBA下单、FBA订单审核
      return this.curRow && this.curRow.className && this.curRow.className === 'FbaJob'
    },
    isCabinJob() { // 是否舱单
      return this.curRow && this.curRow.allocationSerialNumber
    },
    isAssemblyPlan() { // 是否拼装计划
      return this.curRow && this.curRow.className && this.curRow.className === 'AssemblyPlan'
    },
    locationCode() {
      if (this.job) {
        switch (this.job.lob) {
          case 'SE':
            return LOG_SE_SEA_BOOKING_FILE_HISTORY.code
          case 'SI':
            return LOG_SI_SEA_BOOKING_FILE_HISTORY.code
          case 'AE':
            return LOG_AE_SEA_BOOKING_FILE_HISTORY.code
          case 'AI':
            return LOG_AI_SEA_BOOKING_FILE_HISTORY.code
          case 'RE':
          case 'RI':
            return LOG_RE_SEA_BOOKING_FILE_HISTORY.code
        }
      }
      return ''
    },
    uploadParams() {
      const { job: { _data }, user } = this
      return {
        jobNo: _data ? _data.jobNo : '',
        mbl: _data ? _data.mbl : '',
        uuid: _data ? _data.uuid : '',
        createdBy: user.userId,
        createChineseName: user.chineseName,
        createEnglishName: user.englishName,
        documentType: (_data && _data.lob && ['SE', 'SI', 'AE', 'AI', 'IE', 'RE', 'RI'].includes(_data.lob)) ? this.defaultDocumentTypeCode : 'other',
        documentName: (_data && _data.lob && ['SE', 'SI', 'AE', 'AI', 'IE', 'RE', 'RI'].includes(_data.lob)) ? this.defaultDocumentChineseName : 'other',
        isShared: false,
        op: false,
        sales: false,
        cargoSales: false,
        csr: false,
        overseaOp: false,
        dc: false,
        planner: false,
        userDefinedRoleId1: false,
        userDefinedRoleId2: false,
        all: false,
        customer: false,
        consignee: false,
        shipper: false,
        destinationAgent: false,
        bookingAgent: false,
        fileSource: ChargeItemTarget.UPLOAD.code
      }
    },
    isZh() {
      return this.$store.getters.language === 'zh'
    },
    canEditFileType() { // 文件类型是否可以编辑
      return !this.viewSource || (this.viewSource && this.viewSource !== 'trustFromWindow')
    },
    uploadFileInstruction() {
      return this.instructioinBtns.find(p => p.platformInstructionRuleCode === this.UPLOAD_FILE.code)
    },
    remainInstructions() {
      return this.instructioinBtns.filter(p => p.platformInstructionRuleCode !== this.UPLOAD_FILE.code)
    }
  },
  created() {
  },
  mounted() {
    this.$emit('mounted')
  },
  beforeMount() {
    const context = this
    this.documentManage.set('popFileHistoryDetailFormDialog', function(value) {
      context.popFileHistoryDetailFormDialog(value)
    })
    this.documentManage.set('onFileView', function(value) {
      context.onFileView(value)
    })
    this.documentManage.set('handlePreviewFile', function(value) {
      context.handlePreviewFile(value)
    })
  },
  activated() {
    this.resetDropUpload()
  },
  beforeDestroy() {
    this.documentManage.destory()
  },
  methods: {
    /*   const SALES = "sales"
   const OP = "op"
   const ALL  = "all"*/
    async handlePreviewFile(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)

      // CARGO-22751 H5文件历史页签 【预览】没有根据基本配置-文件类型中配置的类型权限控制
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject, true)) {
          return
        }
      }
      this.previewFileData.file = fileObject
      this.previewFileData.visible = true
    },
    // 处理文件后缀名
    getFileType(fileName) {
      let fileType = ''
      if (fileName.indexOf('.') === -1) {
        console.log(this.fileFormat)
        if (this.fileFormat.indexOf('docx') !== -1 || this.fileFormat.indexOf('docx') !== -1 || this.fileFormat.indexOf('word') !== -1 || this.fileFormat.indexOf('xls') !== -1 || this.fileFormat.indexOf('xlsx') !== -1 || this.fileFormat.indexOf('pptx') !== -1) {
          fileType = 'officeType'
        } else if (this.fileFormat.indexOf('pdf') !== -1) {
          fileType = 'pdf'
        } else if (this.fileFormat.indexOf('txt') !== -1) {
          fileType = 'txt'
        }
      } else {
        const arr = fileName.split('.')
        fileType = arr[arr.length - 1].toLowerCase()
      }
      return fileType
    },
    closePreviewDialog() {
      this.previewFileData.file = null
      this.previewFileData.visible = false
    },
    async preloadBasicData() {
      await cache.load(cacheName.USER, cacheName.CONFIG)
      this.user = cache.user
      this.configMap = cache.config
    },
    async onShow(row, isRefresh) {
      if (isRefresh) {
        this.curRow = row
        this.showSlaveFile = false
        await this.preloadBasicData()
        this.ingotButton = parseInt(this.configMap.get('openIngotButton')) === 1
        this.toExoSystemOC = Number(this.configMap.get('ToExoSystem')) === 2
        // CARGO-43586 0:不开启，1：开启同步信息功能（仅支持显示和使用同步信息按钮），2：开启同步文件历史功能（支持显示和使用同步文件历史、取消同步 按钮），3：同时开启（现有开启逻辑）
        this.crossDelegationSynchronizationField = Number(this.configMap.get('crossDelegationSynchronizationField')) === 2 || Number(this.configMap.get('crossDelegationSynchronizationField')) === 3 // 名航模式
        this.oneClickSendDestinationPortAgent = Number(this.configMap.get('OneClickSendDestinationPortAgent')) === 1
        if (this.ingotButton) {
          this.ingotUploadButton = this.$checkPermission(['button_FileHistory_ingotUploadButton'])
          this.ingotButton = this.$checkPermission(['button_FileHistory_ingotLogButton'])
        }
        // 如果是国内仓国外仓进来的数据就不要转成job
        if (this.isWarehouseIn) {
          this.cloudFile.job = new WarehouseIn(row)
          this.job = new WarehouseIn(row)
        } else if (this.isFbaJob) { // 如果是根据UUID绑定的文件就走这里
          this.cloudFile.job = new FbaJob(row)
          this.job = new FbaJob(row)
        } else if (this.isCabinJob) {
          this.cloudFile.job = new CabinManagement(row)
          this.job = new CabinManagement(row)
          this.job.jobNo = this.job.allocationSerialNumber
          this.job.lob = 'SE'
        } else if (this.isAssemblyPlan) {
          this.cloudFile.job = new AssemblyPlan(row)
          this.job = new AssemblyPlan(row)
        } else {
          this.cloudFile.job = new Job(row)
          this.job = new Job(row)
        }
        this.showSendPackageProxyFilesButton = this.job.virtualHBL || (this.job.lclSlaves && this.job.lclSlaves.findIndex(p => p.virtualHBL) >= 0)
        await this.resetDropUpload()
        this.toQuery()
        if (this.isAssemblyPlan) {
          // 拼装计划-文件历史，暂不加载指令
          return
        }
        this.loadInstructionBtns()
      }
    },
    async resetDropUpload() {
      let defaultDocumentTypeCode = ''
      let defaultDocumentChineseName = ''
      this.fileTypeMap.clear()
      this.fileTypeCapsMap.clear()
      this.docType = []
      const openXHQDocumentCenter = this.configMap.get('OpenXHQDocumentCenter') !== '0'
      await DocumentCategory.getDocCategoryTypeTreeByLob({ constructLobParent: false, lob: this.job.lob }).then(res => {
        res.data.forEach(item => {
          if (item.type === 2) {
            const value = this.isZh ? item.chineseName : item.englishName
            if (openXHQDocumentCenter) { // 开启信号旗单证中心的参数时，显示列根据code匹配文件类型忽略大小写
              this.fileTypeMap.set(StrUtils.toUpperCase(item.code), value)
            } else {
              this.fileTypeMap.set(item.code, value)
            }
            this.fileTypeCapsMap.set(StrUtils.toUpperCase(item.code), item.chineseName)
            this.docType.push(item)
            if (item.defaultDocumentType) {
              defaultDocumentTypeCode = item.code
              defaultDocumentChineseName = item.chineseName
            }
          }
        })
      })
      this.defaultDocumentTypeCode = defaultDocumentTypeCode
      this.defaultDocumentChineseName = defaultDocumentChineseName
      this.dropAutoUpload = !(['SE', 'SI', 'AE', 'AI', 'IE', 'RE', 'RI'].includes(this.job.lob) && !defaultDocumentTypeCode)
    },
    // 加载指令按钮
    async loadInstructionBtns() {
      if (!this.showInstruction) {
        this.instructioinBtns = []
        return
      }
      const useHqSet = UICustomUtil.getUseHqSet(UICustomConstants.SEA_BOOKING_FILE_HISTORY, this.$store.getters.currentOfficeId)
      const res = await getJobInstructions({
        pageType: UICustomConstants.SEA_BOOKING_FILE_HISTORY,
        branchId: this.$store.getters.currentOfficeId,
        useHqSet,
        jobKey: this.job.uuid,
        lob: this.job.lob
      })
      this.instructioinBtns = res.data
    },
    /* 转换文件类型中文名称*/
    fileTypeLabelFunction: function(value) {
      if (!value) return this.$t('Message.Other')
      const openXHQDocumentCenter = this.configMap.get('OpenXHQDocumentCenter') !== '0'
      let returnVal = ''
      const codes = value.split(',')
      for (let i = 0; i < codes.length; i++) {
        if (openXHQDocumentCenter) { // 开启信号旗单证中心的参数时，显示列根据code匹配文件类型忽略大小写
          codes[i] = StrUtils.toUpperCase(codes[i])
        }
        if (returnVal === '') {
          returnVal = this.fileTypeMap.get(codes[i]) || this.$t('Message.Other')
        } else {
          returnVal = returnVal + ',' + (this.fileTypeMap.get(codes[i]) || this.$t('Message.Other'))
        }
      }
      return returnVal
    },
    /* 文件大小转换*/
    fileSizeColumnLabel: function(value) {
      if (value !== '' && !isNaN(value)) {
        return (value / 1024).toFixed(2) + ' KB'
      }
      return ''
    },
    showCloudFile(newFile = null) {
      this.cloudFile.newFile = newFile
      this.cloudFile.visible = true
    },
    refreshPrintStatusSafe(jobUuids) {
      const list = Array.isArray(jobUuids) ? jobUuids : [jobUuids]
      const uniq = [...new Set(list.filter(p => !StrUtils.isEmpty(p)))]
      for (const jobUuid of uniq) {
        refreshPrintStatus(jobUuid).catch(() => {})
      }
    },
    updateSop(rowData) {
      // 提取documentTypeUuid
      let documentTypeUuid = ''
      if (rowData) {
        for (const item of rowData) {
          if (documentTypeUuid) {
            documentTypeUuid += ','
          }
          documentTypeUuid += item.documentTypeUuid
        }
      }
      // todo 由文件上传 控件回传 documentTypeUuid
      // const documentTypeUuid = '' // 多个由 , 拼接
      const objParams = {
        jobUuid: this.job.uuid,
        docKeys: documentTypeUuid
      }
      updateTrackingForDocumentType(objParams)
      this.refreshPrintStatusSafe(this.job.uuid)
      this.toQuery()
    },
    toQuery: async function() {
      this.storageURL = this.configMap.get('StorageURL')
      const jobs = [this.job]
      if (this.showSlaveFile && this.job.lclSlaves) {
        jobs.push(...this.job.lclSlaves)
      }
      const xmlParamList = Array.from(jobs, job => {
        let xmlParam = '<RequestObject><data><extendMetaData><entry><key>jobNo</key><value>' +
          job.jobNo +
          '</value></entry></extendMetaData></data></RequestObject>'
        if (this.isWarehouseIn || this.isFbaJob || this.isCabinJob || this.isAssemblyPlan) {
          xmlParam = '<RequestObject><data><extendMetaData><entry><key>uuid</key><value>' +
            job.uuid +
            '</value></entry></extendMetaData></data></RequestObject>'
        }
        return xmlParam
      })
      await getFileListByMultiParam(xmlParamList).then(res => {
        res.data = this.checkDocTypes(res.data)
        this.rowData = Array.from(res.data, p => {
          return {
            fileId: p.id,
            fileName: p.fileName,
            fileType: p.extendMetaData.documentType || '',
            fileFormat: p.fileType.split(';')[0],
            fileSize: p.fileSize,
            fileVersion: p.fileVersion || '',
            createDate: p.createDate,
            synchronizationState: p.extendMetaData.synchronizationState,
            createChineseName: p.extendMetaData.createChineseName || '',
            createdBy: p.extendMetaData.createdBy,
            fileSource: p.extendMetaData.fileSource || '',
            extendMetaData: p.extendMetaData,
            fileNameBak: p.fileName,
            lastSyncTime: p.extendMetaData.syncTime,
            lastEmailSentTime: p.extendMetaData.lastEmailSentTime || '',
            path: '',
            hasParent: false,
            parentId: '',
            jobNo: p.extendMetaData.jobNo
          }
        })
      })
      if (this.toExoSystemOC && this.rowData.length > 0) {
        const jobKeys = Array.from(jobs, p => p.uuid).join(',')
        await getOcFileListByJobKeys(jobKeys).then(res => {
          const ocFiles = res.data
          if (ocFiles && ocFiles.length > 0) {
            for (const file of this.rowData) {
              for (const ocFile of ocFiles) {
                if (file.fileId === ocFile.fileId) {
                  file.externalFileType = ocFile.externalFileType
                  file.lastSyncTime = ocFile.lastSyncTime
                  break
                }
              }
            }
          }
        })
      }
      this.getFilesSucceedHandler()
    },
    checkDocTypes(data) {
      if (!this.$store.getters.isAdmin) {
        const roles = ['sales', 'op', 'userDefinedRole1', 'userDefinedRole2', 'customer', 'shipper', 'consignee', 'destinationAgent', 'bookingAgent', 'shared', 'csr', 'dc', 'overseaOp', 'salesOfGoods', 'railwayLine', 'sealine', 'airline', 'doc']
        const hasRoleMap = new Map()
        for (const role of roles) {
          hasRoleMap.set(role, this.$checkPermission(['role_' + role]))
        }
        data = data.filter(p => {
          const fileTypes = this.getFileTypes(p.extendMetaData.documentType)
          if (fileTypes && fileTypes.length > 0) {
            for (const fileType of fileTypes) {
              // 针对于自定义岗位字段，和权限的key不一致，需要转换一下
              if (fileType.hasOwnProperty('userDefinedRoleId1') && !fileType.hasOwnProperty('userDefinedRole1')) {
                fileType.userDefinedRole1 = fileType.userDefinedRoleId1
              }
              if (fileType.hasOwnProperty('userDefinedRoleId2') && !fileType.hasOwnProperty('userDefinedRole2')) {
                fileType.userDefinedRole2 = fileType.userDefinedRoleId2
              }
              // 揽货销售字段和权限key不一致，进行转换
              if (fileType.hasOwnProperty('cargoSales') && !fileType.hasOwnProperty('salesOfGoods')) {
                fileType.salesOfGoods = fileType.cargoSales
              }
              // 单证字段和权限key不一致，进行转换
              if (fileType.hasOwnProperty('dc') && !fileType.hasOwnProperty('doc')) {
                fileType.doc = fileType.dc
              }
              // 航线负责人字段和权限key不一致，进行转换
              switch (this.job.lob) {
                case 'SE':
                case 'SI':
                  if (fileType.hasOwnProperty('planner') && !fileType.hasOwnProperty('sealine')) {
                    fileType.sealine = fileType.planner
                  }
                  break
                case 'AE':
                case 'AI':
                  if (fileType.hasOwnProperty('planner') && !fileType.hasOwnProperty('airline')) {
                    fileType.airline = fileType.planner
                  }
                  break
                case 'RE':
                  if (fileType.hasOwnProperty('planner') && !fileType.hasOwnProperty('railwayLine')) {
                    fileType.railwayLine = fileType.planner
                  }
                  break
              }
              if (fileType.checkPrivilegePerson && !fileType.other) {
                for (const role of roles) {
                  if (fileType[role] && hasRoleMap.get(role)) {
                    return true
                  }
                }
                if (fileType.designatePersons && fileType.designatePersons.split(',').includes(this.$store.getters.userId + '')) {
                  return true
                }
              } else {
                return true
              }
            }
            console.log('hasRoleMap===3', fileTypes)
            return false
          }
          return true
        })
      }
      return data
    },
    getFileTypes(value) {
      const codes = (value || 'OTHER').split(',')
      const result = []
      for (const code of codes) {
        let docType = this.docType.find(p => p.code.toUpperCase() === code.toUpperCase())
        if (!docType) {
          docType = this.docType.find(p => p.code.toUpperCase() === 'OTHER')
        }
        if (docType) {
          result.push(docType)
        }
      }
      return result
    },
    /* 文件列表 父级和子级组装*/
    getFilesSucceedHandler: function() {
      // 排序后放入临时对象数据
      const rowDataTempt = sortByMultiField(this.rowData, ['fileName', 'fileVersion', 'createDate'], true)
      if (!rowDataTempt || rowDataTempt.length === 0) {
        return
      }
      let fatherFile = rowDataTempt[0]
      // 初始化 首个父节点的path
      fatherFile.path = fatherFile.fileId
      fatherFile.hasParent = false
      const source = []
      source.push(fatherFile)
      let childFile
      for (let i = 1; i < rowDataTempt.length; i++) {
        childFile = rowDataTempt[i]
        childFile.hasParent = false
        if (childFile.fileName === fatherFile.fileName && childFile.fileSource === fatherFile.fileSource) {
          if (fatherFile.hasParent) {
            childFile.path = fatherFile.parentId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.parentId
          } else {
            childFile.path = fatherFile.fileId + ',' + childFile.fileId
            childFile.hasParent = true
            childFile.parentId = fatherFile.fileId
          }
          // childFile.fileName = ''
        } else {
          // 遍历到父节点了
          childFile.path = childFile.fileId
        }
        source.push(childFile)
        fatherFile = childFile
      }
      // 数据组装后 父级再次排序 根据createDate fileName
      let parentFileList = source.filter(val => {
        return val.hasParent === false
      })
      const childFileList = source.filter(val => {
        return val.hasParent === true
      })
      parentFileList = sortByMultiField(parentFileList, ['createDate', 'fileName'], true)

      const fileList = [...parentFileList, ...childFileList]
      console.log(fileList)
      this.rowData = fileList
    },
    onFileView(value) {
      const fileObject = this.rowData.find(x => x.fileId === value)
      // 测试 编辑保存
      // this.itemEditEndHandler(fileObject)

      // 判断是否有下载文件的权限
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!this.checkDownloadFile(fileObject)) {
          return
        }
      }
      // 检查文件查询权限
      if (fileObject.extendMetaData.hasOwnProperty('documentType')) {
        if (!this.checkFileDocTypeRole(fileObject, true)) {
          return
        }
      }

      const url = URL.common.findByFileId + `/${value}?sessionId=${this.context.user.sessionId}`
      window.open(url)
    },
    checkDownloadFile(data) {
      if (Number(data.createdBy) !== this.user.userId) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToViewOrprinted'))
        return false
      }
      return true
    },
    checkFileDocTypeRole(data, isMarked) {
      let documentType = data.extendMetaData.documentType
      if (documentType === this.$t('Message.Other')) {
        documentType = 'OTHER'
      }
      if (documentType === 'other' || documentType === 'Other') {
        documentType = documentType.toLocaleUpperCase()
      }
      const result = this.getDocType(documentType)
      if (!result || result.length === 0) {
        return true
      }

      if (this.user.admin || parseInt(data.createdBy) === this.user.userId) {
        return true
      }
      const fileRoleMap = this.getFileRoleMap(result)
      if (fileRoleMap.length === 0) {
        // 查看或下载的操作进行弹窗
        if (isMarked) {
          this.$message.warning(this.$t('SeaExport.FileNotAllowedView').replace('{0}', data.fileName))
        }
        return false
      }
      let isView = false
      if (this.$checkPermission(['role_sales']) && fileRoleMap.indexOf('sales') !== -1) {
        isView = true
      }
      if (this.$checkPermission(['role_op']) && fileRoleMap.indexOf('op') !== -1) {
        isView = true
      }
      // 揽货销售
      if (this.$checkPermission(['role_salesOfGoods']) && fileRoleMap.indexOf('cargoSales') !== -1) {
        isView = true
      }
      // 客服
      if (this.$checkPermission(['role_csr']) && fileRoleMap.indexOf('csr') !== -1) {
        isView = true
      }
      // 海外客服
      if (this.$checkPermission(['role_overseaOp']) && fileRoleMap.indexOf('overseaOp') !== -1) {
        isView = true
      }
      // 单证
      if (this.$checkPermission(['role_doc']) && fileRoleMap.indexOf('dc') !== -1) {
        isView = true
      }
      // 航线负责人
      const lob = this.job ? this.job.lob : ''
      let isPermission = false
      if (lob === SystemConstants.SE.code || lob === SystemConstants.SI.code) {
        isPermission = this.$checkPermission(['role_sealine']) // 海运
      } else if (lob === SystemConstants.AE.code || lob === SystemConstants.AI.code) {
        isPermission = this.$checkPermission(['role_airline']) // 空运
      } else if (lob === SystemConstants.RE.code || lob === SystemConstants.RI.code) {
        isPermission = this.$checkPermission(['role_railwayLine']) // 铁路
      }
      if (isPermission && fileRoleMap.indexOf('planner') !== -1) {
        isView = true
      }
      // 自定义岗位Id1
      if (this.$checkPermission(['role_userDefinedRole1']) && fileRoleMap.indexOf('userDefinedRoleId1') !== -1) {
        isView = true
      }
      // 自定义岗位Id2
      if (this.$checkPermission(['role_userDefinedRole2']) && fileRoleMap.indexOf('userDefinedRoleId2') !== -1) {
        isView = true
      }
      if (!isView && fileRoleMap.indexOf('all') !== -1) {
        isView = true
      }
      // 查看或下载的操作进行弹窗
      if (!isView && isMarked) {
        this.$message.warning(this.$t('SeaExport.NoPermissionToView').replace('{0}', data.fileName))
        return
      }
      return isView
    },
    //  文档属性权限
    getFileRoleMap(result) {
      const fileRoleMap = []
      if (this.getDocTypeRole('sales', result)) {
        fileRoleMap.push('sales')
      }
      if (this.getDocTypeRole('op', result)) {
        fileRoleMap.push('op')
      }
      if (this.getDocTypeRole('cargoSales', result)) {
        fileRoleMap.push('cargoSales')
      }
      if (this.getDocTypeRole('csr', result)) {
        fileRoleMap.push('csr')
      }
      if (this.getDocTypeRole('overseaOp', result)) {
        fileRoleMap.push('overseaOp')
      }
      if (this.getDocTypeRole('dc', result)) {
        fileRoleMap.push('dc')
      }
      if (this.getDocTypeRole('planner', result)) {
        fileRoleMap.push('planner')
      }
      if (this.getDocTypeRole('userDefinedRoleId1', result)) {
        fileRoleMap.push('userDefinedRoleId1')
      }
      if (this.getDocTypeRole('userDefinedRoleId2', result)) {
        fileRoleMap.push('userDefinedRoleId2')
      }
      if (this.getDocTypeRole('all', result)) {
        fileRoleMap.push('all')
      }
      return fileRoleMap
    },
    onFileTypeCellFocused(event) {
      if (event.column && event.column && event.column.colId === 'fileType' && this.canOperateJob && this.canEditFileType) {
        const selected = this.getSelectedHandler(event)
        // 被同步的文件不可编辑
        if (selected.extendMetaData['sourceId']) {
          this.$message.warning(this.$t('Message.TheSynchronizedFileCannotBeEdited'))
          return
        }
        if (selected) {
          if (!this.user.admin && !this.$checkPermission(['role_FileHistory_editAllFile'])) {
            if (Number(selected.createdBy) !== this.user.userId) {
              this.$message.warning(this.$t('Message.NotPermissionToEditFilesByOtherUsers'))
              return
            }
          }
          this.fileTypeEdit(selected)
        }
      }
    },
    getSelectedHandler(event) {
      let selectData = null
      this.gridOptions.api.forEachNode(node => {
        if (node.rowIndex === event.rowIndex) {
          selectData = node.data
        }
      })
      return selectData
    },
    fileTypeEdit(data) {
      this.fileTypeEditor.fileId = data.fileId
      this.fileTypeEditor.fileCategory = data.fileType
      this.fileTypeEditor.visible = true
    },
    // 文件类型 编辑保存
    async itemEditEndHandler(data) {
      const item = this.rowData.find(p => p.fileId === data.fileId)
      const documentType = data.fileCategory
      const documentName = data.fileCategoryLabel // item.extendMetaData['documentName']
      if (item.extendMetaData && data && data.docTypeRows && data.docTypeRows.length > 0) {
        const docType = data.docTypeRows[0]
        if (!docType) {
          return
        }
        item.extendMetaData = JobUtils.setUploadFileParam(item.extendMetaData, docType)
      }
      const isShared = item.extendMetaData['isShared']
      const op = item.extendMetaData['op']
      const sales = item.extendMetaData['sales']
      const cargoSales = item.extendMetaData['cargoSales']
      const csr = item.extendMetaData['csr']
      const overseaOp = item.extendMetaData['overseaOp']
      const dc = item.extendMetaData['dc']
      const planner = item.extendMetaData['planner']
      const userDefinedRoleId1 = item.extendMetaData['userDefinedRoleId1']
      const userDefinedRoleId2 = item.extendMetaData['userDefinedRoleId2']
      const all = item.extendMetaData['other']
      const customer = item.extendMetaData['customer']
      const consignee = item.extendMetaData['consignee']
      const b2bCustomer = item.extendMetaData['b2bCustomer']
      const b2bDesignationAgent = item.extendMetaData['b2bDesignationAgent']
      const b2bDestinationAgent = item.extendMetaData['b2bDestinationAgent']
      const b2bConsignee = item.extendMetaData['b2bConsignee']
      const shipper = item.extendMetaData['shipper']
      const destinationAgent = item.extendMetaData['destinationAgent']
      const bookingAgent = item.extendMetaData['bookingAgent']
      const synchronizationState = item.extendMetaData['synchronizationState']
      const xmlParam = `<RequestObject>
      <fileId>${item.fileId}</fileId>
      <extendMetaData>
      <entry>
      <key>documentType</key>
      <value>${documentType}</value>
      </entry>
      <entry>
      <key>documentName</key>
      <value>${documentName}</value>
      </entry>
      <entry>
      <key>isShared</key>
      <value>${isShared}</value>
      </entry>
      <entry>
      <key>op</key>
      <value>${op}</value>
      </entry>
      <entry>
      <key>sales</key>
      <value>${sales}</value>
      </entry>
      <entry>
      <key>cargoSales</key>
      <value>${cargoSales}</value>
      </entry>
      <entry>
      <key>csr</key>
      <value>${csr}</value>
      </entry>
      <entry>
      <key>overseaOp</key>
      <value>${overseaOp}</value>
      </entry>
      <entry>
      <key>dc</key>
      <value>${dc}</value>
      </entry>
      <entry>
      <key>planner</key>
      <value>${planner}</value>
      </entry>
      <entry>
      <entry>
      <key>userDefinedRoleId1</key>
      <value>${userDefinedRoleId1}</value>
      </entry>
      <entry>
      <key>userDefinedRoleId2</key>
      <value>${userDefinedRoleId2}</value>
      </entry>
      <key>all</key>
      <value>${all}</value>
      </entry>
      <entry>
      <key>customer</key>
      <value>${customer}</value>
      </entry>
      <entry>
      <key>consignee</key>
      <value>${consignee}</value>
      </entry>
      <entry>
      <key>b2bCustomer</key>
      <value>${b2bCustomer}</value>
      </entry>
      <entry>
      <key>b2bDesignationAgent</key>
      <value>${b2bDesignationAgent}</value>
      </entry>
      <entry>
      <key>b2bDestinationAgent</key>
      <value>${b2bDestinationAgent}</value>
      </entry>
      <entry>
      <key>b2bConsignee</key>
      <value>${b2bConsignee}</value>
      </entry>
      <entry>
      <key>shipper</key>
      <value>${shipper}</value>
      </entry>
      <entry>
      <key>destinationAgent</key>
      <value>${destinationAgent}</value>
      </entry>
      <entry>
      <key>bookingAgent</key>
      <value>${bookingAgent}</value>
      </entry>
      <entry>
      <key>synchronizationState</key>
      <value>${synchronizationState}</value>
      </entry>
      </extendMetaData>
      </RequestObject>`
      await saveMetaData(xmlParam)
      if (Number(cache.hqConfig.get('FileAutoSynchronization')) === 1) {
        if ((!synchronizationState || synchronizationState === '0') && (this.job.trustFromJob || this.job.relatedJob)) {
          const isExport = this.job.lob === 'SE' || this.job.lob === 'AE'
          const isExportToImportJob = this.job.relatedJobLob && this.job.relatedJobLob !== this.job.lob
          const isTrust = this.job.relatedJob
          let isNeedSync = false
          for (const docType of data.docTypeRows) {
            if (isExportToImportJob) {
              if (docType.isExportToImportMode && docType.exportImportSyncFileMode === 2) {
                if ((isExport && docType.isExportToImport) || (!isExport && docType.isImportToExport)) {
                  isNeedSync = true
                  break
                }
              }
            } else {
              if (docType.isCrossTrustMode && docType.trustSyncFileMode === 2) {
                if ((isTrust && docType.isTrustToOperate) || (!isTrust && docType.isOperateToTrust)) {
                  isNeedSync = true
                  break
                }
              }
            }
          }
          if (isNeedSync) {
            await syncJobFiles({ jobKey: this.job.uuid, fileIds: data.fileId })
          }
        }
      }
      this.refreshPrintStatusSafe((item && item.extendMetaData && item.extendMetaData.uuid) || this.job.uuid)
      this.toQuery()
    },
    remove() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('common.tips.hasOneAtleast'))
        return
      }
      const fileDeleteRole = this.$checkPermission(['button_FileHistory_fileDelete'])
      const ownFileDeleteRole = this.$checkPermission(['role_FileDownloads_ownFileDelete'])
      for (const item of rows) {
        if (!fileDeleteRole && ownFileDeleteRole) {
          if (!item.extendMetaData || (this.$store.getters.userId !== Number(item.extendMetaData.createdBy))) {
            this.$message.warning(this.$t('CargoMsg.Cargo_OwnFileDelete'))
            return
          }
        }
      }
      this.$confirm(this.$t('SeaExport.DeleteNumFile').replace('{0}', rows.length), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(async() => {
        try {
          const jobKeySet = new Set()
          const guaranteeFileId = new Set()
          for (const item of rows) {
            if (item.sourceId) {
              this.$message.warning(this.$t('Message.TheSynchronizedFileIsNotDeleted'))
              return
            }
            const data = {
              fileName: item.fileName,
              location: this.locationCode,
              jobUuid: this.job ? this.job.uuid : '',
              branchId: this.$store.getters.currentOfficeId
            }
            const isSuccess = await deleteFile(item.fileId, data).then(res => res.data === 'success')
            if (isSuccess) {
              item.isDeleted = true
              jobKeySet.add(item.extendMetaData.uuid)
              if (item.extendMetaData.documentCategory && DocumentConstants.SINGLE_TICKET_GUARANTEE_TYPES.some(obj => obj.code === Number(item.extendMetaData.documentCategory))) {
                guaranteeFileId.add(item.fileId)
              }
            } else {
              break
            }
          }
          this.refreshPrintStatusSafe([...jobKeySet])
          this.sendFileOC([...jobKeySet])
          if (guaranteeFileId.size) {
            batchDeletedByFileId([...guaranteeFileId]).then(res => {})
          }
        } finally {
          this.rowData = this.rowData.filter(p => !p.isDeleted)
          this.getFilesSucceedHandler()
        }
      }).catch(() => {
      })
    },
    download() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileToDownloadOrSend'))
        return
      }
      // 判断是否有权限
      if (!this.validate(rows)) {
        return
      }
      if (rows.length === 1) {
        window.open(`${URL.common.findByFileId}/${rows[0].fileId}?sessionId=${this.context.user.sessionId}`)
      } else {
        const fileIds = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
        const fileName = this.cloudFile.job.jobNo + '.zip'
        window.open(`${URL.common.compressFiles}?sessionId=${this.context.user.sessionId}&fileIds=${fileIds}&fileName=${fileName}`)
      }
    },
    validate(fileList) {
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        if (!fileList || fileList.length <= 0) return true
        for (const file of fileList) {
          if (!this.checkDownloadFile(file)) {
            return false
          }
        }
      }
      if (!fileList || fileList.length <= 0) return true
      for (const file of fileList) {
        if (file.extendMetaData.hasOwnProperty('documentType')) {
          return this.checkFileDocTypeRole(file, true)
        }
      }
      return true
    },
    // 查看详情
    popFileHistoryDetailFormDialog: function(value) {
      this.isShowingDetailForm = true
      const fileObject = this.rowData.find(x => x.fileId === value)
      const extendMetaData = fileObject.extendMetaData
      this.showDetailTitle = fileObject.fileName + '_' + fileObject.fileVersion

      const roles = ['op', 'sales', 'cargoSales', 'csr', 'overseaOp', 'dc', 'planner', 'all', 'customer', 'consignee', 'shipper', 'destinationAgent', 'bookingAgent', 'userDefinedRoleId1', 'userDefinedRoleId2', 'b2bCustomer', 'b2bDesignationAgent', 'b2bDestinationAgent', 'b2bConsignee']

      var docTypeFilter = null
      // 文件类型转换
      if (extendMetaData.hasOwnProperty('documentType')) {
        var documentType = extendMetaData.documentType
        if (documentType === this.$t('Message.Other')) {
          documentType = 'OTHER'
        }
        if (documentType === 'other' || documentType === 'Other') {
          documentType = documentType.toLocaleUpperCase()
        }
        //  根据文件类型code 获取相关属性
        docTypeFilter = this.getDocType(documentType)
      }

      const extendMetaDataSort = this.objKeySort(extendMetaData)
      const tempFileDetailList = []
      for (const key in extendMetaDataSort) {
        if (key === 'entry' || key === 'createdBy') {
          continue
        }
        let keyValue
        if (roles.includes(key) && docTypeFilter != null) {
          keyValue = this.getDocTypeRole(key, docTypeFilter) ? this.$t(`SeaExport.Accessible`) : ''
        } else {
          keyValue = extendMetaData[key]
        }
        const convertKeyName = this.keyLabFunc(key)

        var keyName
        keyName = this.$t(`SeaExport.${convertKeyName}`)
        if (keyName === 'SeaExport.') {
          keyName = key
        }
        /* 资源文件未转义 特殊处理直接赋值*/
        if (keyName === 'SeaExport.bookingAgent') {
          keyName = this.$t('SeaExport.BookingAgent')
        }
        if (key === 'userDefinedRoleId1') {
          keyName = this.$t('CargoMsg.Cargo_userDefinedRole1')
        }
        if (key === 'userDefinedRoleId2') {
          keyName = this.$t('CargoMsg.Cargo_userDefinedRole2')
        }
        if (keyName === 'SeaExport.hblNo') {
          keyName = 'hbl'
        }
        const json = { 'key': keyName, 'val': keyValue }
        tempFileDetailList.push(json)
      }
      this.rowDataFileDetail = tempFileDetailList
    },
    // 获取 获取属性访问权限
    getDocTypeRole(roleKey, docType) {
      if (docType === null || docType.length === 0) {
        return false
      }
      if (roleKey === 'all') {
        roleKey = 'other'
      }
      for (let i = 0; i < docType.length; i++) {
        if (docType[i][roleKey]) {
          return true
        }
      }

      return false
    },
    // 获取code所关联的XML 原cargo getDocTypeXml
    getDocType(codes) {
      const docTypeFilter = []
      if (codes == null || codes === '') {
        return null
      }
      const codeArray = codes.split(',')
      for (let i = 0; i < codeArray.length; i++) {
        const docObject = this.docType.find(x => x.code === codeArray[i])
        if (docObject != null) {
          docTypeFilter.push(docObject)
        }
      }
      return docTypeFilter
    },
    /* json 根据 key 的名称排序的函数*/
    objKeySort(obj) {
      var newkey = Object.keys(obj).sort()
      var newObj = {}
      for (var i = 0; i < newkey.length; i++) {
        newObj[newkey[i]] = obj[newkey[i]]
      }
      return newObj
    },
    // 转换对应的 中文定义的keyName
    keyLabFunc(value) {
      let convertKeyName = ''
      switch (value) {
        case 'op':
          convertKeyName = 'Operation'
          break
        case 'sales':
          convertKeyName = 'Sales'
          break
        case 'cargoSales':
          convertKeyName = 'SalesOfGoods'
          break
        case 'csr':
          convertKeyName = 'CustomerService'
          break
        case 'overseaOp':
          convertKeyName = 'OverseaCustomerService'
          break
        case 'dc':
          convertKeyName = 'Documents'
          break
        case 'planner':
          convertKeyName = 'AirlinePerson2'
          break
        case 'all':
          convertKeyName = 'AllPositions'
          break
        case 'customer':
          convertKeyName = 'ConsignationCompany'
          break
        case 'consignee':
          convertKeyName = 'Consignee'
          break
        case 'shipper':
          convertKeyName = 'Shipper'
          break
        case 'destinationAgent':
          convertKeyName = 'DestinationAgent'
          break
        case 'bookingAgent':
          convertKeyName = 'bookingAgent'
          break
        case 'hblNo':
          convertKeyName = 'hblNo'
          break
        case 'hblRefNo':
          convertKeyName = 'hblRefNo'
          break
      }
      return convertKeyName
    },
    sendEmail() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileToDownloadOrSend'))
        return
      }

      if (this.validateSendEmail(rows)) {
        return
      }

      this.sendEmailDialog.visible = true
      this.sendEmailDialog.emailTitle = Array.from(rows, p => p.fileName).reduce((a, b) => a + ';' + b)
      this.sendEmailDialog.fileIdList = Array.from(rows, p => p.fileId).reduce((a, b) => a + ',' + b)
      this.sendEmailDialog.fileList = rows
    },
    validateSendEmail(fileList) {
      if (!fileList || fileList.length <= 0) return true
      let fileNames = ''
      if (!this.$checkPermission(['button_FileHistory_fileDownloads'])) {
        for (const file of fileList) {
          if (Number(file.createdBy) !== this.user.userId) {
            fileNames = fileNames + '【' + file.fileName + '】'
          }
        }
      }
      if (fileNames) {
        this.$message.warning(this.$t('Message.NotPermissionToViewFiles', [fileNames]))
        return true
      }
      for (const file of fileList) {
        if (file.extendMetaData.hasOwnProperty('documentType')) {
          if (!this.checkFileDocTypeRole(file, false)) {
            fileNames = fileNames + '【' + file.fileName + '】'
          }
        }
      }
      if (fileNames) {
        this.$message.warning(this.$t('Message.NotPermissionToViewFiles', [fileNames]))
        return true
      }
    },
    // ingot上传
    ingotUpload() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.info(this.$t('Message.PleaseSelectAFileToDownloadOrSend'))
        return
      }
      this.$confirm(this.$t('SeaExport.ConfirmUploadFileType'), this.$t('common.tips.prompt'), {
        confirmButtonText: this.$t('common.btn.ok'),
        cancelButtonText: this.$t('common.btn.cancel'),
        type: 'warning'
      }).then(() => {
        const data = {}
        for (const d of rows) {
          let documentType = ''
          if (d.extendMetaData.documentType) {
            documentType = d.extendMetaData.documentType
            if (!IngotType.inIngotTypeByStrings(documentType)) {
              this.$message.info(this.$t('SeaExport.UploadedFileNotMatch'))
              return
            }
          } else {
            this.$message.info(this.$t('SeaExport.UploadedFileNotMatch'))
            return
          }
          const jobUuid = d.extendMetaData.uuid
          if (!data[jobUuid]) {
            data[jobUuid] = []
          }
          data[jobUuid].push(d.fileId + '|' + d.fileName + '|' + documentType)
        }
        // 发起提箱业务请求
        this.$message.info('上传中,请稍等......')
        // console.log('========rows', rows)
        console.log('========param', data)
        ingotUploadByJobs(data).then(res => {
          const result = res.data
          if (result === 1) {
            this.$message.success(this.$t('SeaExport.UploadSuccess'))
          } else if (result === 2) {
            this.$message.info(this.$t('SeaExport.UploadSuccessNoOrder'))
          } else {
            this.$message.error(this.$t('SeaExport.UploadFailed'))
          }
        })
      }).catch(() => {})
    },
    // ingot日志
    ingotLog() {
      this.ingot.visible = true
      let jobKeys = this.job.uuid
      if (this.showSlaveFile && this.job.lclSlaves && this.job.lclSlaves.length > 0) {
        jobKeys += ',' + Array.from(this.job.lclSlaves, p => p.uuid).join(',')
      }
      queryIngotUploadListByJobs(jobKeys).then(res => {
        this.ingot.rowData = res.data
      })
    },
    ingotClose() {
      this.ingot.visible = false
      this.ingot.rowData = []
    },
    synchronizationFile() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileSynchronization'))
        return
      }
      const data = {}
      for (var i = 0; i < rows.length; i++) {
        if (!rows.sourceId) {
          const jobUuid = rows[i].extendMetaData.uuid
          if (!data[jobUuid]) {
            data[jobUuid] = []
          }
          data[jobUuid].push(rows[i].fileId)
        }
      }
      if (Object.keys(data).length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileSynchronization'))
        return
      }
      const loading = getLoading()
      synchronizationFileByJobs(data).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        this.toQuery()
      }).finally(() => loading.close())
    },
    cancelSynchronization() {
      const rows = this.gridApi.getSelectedRows()
      if (rows.length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileCancelSynchronization'))
        return
      }
      const data = {}
      for (var i = 0; i < rows.length; i++) {
        if (rows[i].synchronizationState === '1') {
          const jobUuid = rows[i].extendMetaData.uuid
          if (!data[jobUuid]) {
            data[jobUuid] = []
          }
          data[jobUuid].push(rows[i].fileId)
        }
      }
      if (Object.keys(data).length === 0) {
        this.$message.warning(this.$t('Message.PleaseSelectAFileCancelSynchronization'))
        return
      }
      const loading = getLoading()
      cancelSynchronizationByJobs(data).then(res => {
        this.$message.success(this.$t('CargoMsg.Cargo_OperationSuccessfully'))
        this.toQuery()
      }).finally(() => loading.close())
    },
    uploadEnd() {
      this.sendFileOC()
      this.refreshPrintStatusSafe(this.job.uuid)
      this.toQuery()
    },
    sendFileOC(jobKeys) {
      if (this.toExoSystemOC) {
        if (!jobKeys) {
          jobKeys = [this.job.uuid]
        }
        sendFileByJobKeys(jobKeys).then(res => { console.log('sendFileOC', res) })
      }
    },
    externalFileTypeLabelFunc(value) {
      if (!value) return ''
      for (const common of FileType.EXTERNAL_FILE_TYPES) {
        if (common.code === value) {
          return common.chineseName
        }
      }
      return ''
    },
    showSlaveFileChange() {
      this.toQuery()
      if (this.showSlaveFile) {
        const jobKeys = [this.job.uuid]
        this.sendEmailDialog.jobUuidList = jobKeys
        this.pushResultLogDialog.jobKeys = jobKeys
      } else {
        this.sendEmailDialog.jobUuidList = null
        this.pushResultLogDialog.jobKeys = null
      }
    },
    /**
     * CARGO-34448 SOP 文件历史的文件类型作为触发条件，需要上传之后更改文件类型也可以自动触发节点
     * 更改文件类型触发sop
     * @param data
     */
    updateSopForFileType(data) {
      if (!data || !data.documentTypeUuid || !this.job || !this.job.uuid) {
        return
      }
      const objParams = {
        jobUuid: this.job.uuid,
        docKeys: data.documentTypeUuid
      }
      updateTrackingForDocumentType(objParams)
    },
    sendPackageAgent(item = {}) {
      const exchangeAgentSet = new Set()
      if (this.job.exChangeAgent) {
        exchangeAgentSet.add(this.job.exChangeAgent)
      }
      if (this.job.lclSlaves) {
        for (const slave of this.job.lclSlaves) {
          if (slave.exChangeAgent) {
            exchangeAgentSet.add(slave.exChangeAgent)
          }
        }
      }
      this.exchangeAgentSelectDialog.jobUuid = this.job.uuid
      this.exchangeAgentSelectDialog.exchangeAgents = [...exchangeAgentSet]
      this.exchangeAgentSelectDialog.selectData = null
      this.exchangeAgentSelectDialog.instruction = item
      this.exchangeAgentSelectDialog.visible = true
    },
    onSelectExchangeAgent(data) {
      this.exchangeAgentSelectDialog.selectData = data
      const instruction = this.exchangeAgentSelectDialog.instruction
      const instructionRuleJson = instruction.instructionRuleJson || {}
      const instructionParamJson = instruction.instructionParamJson || {}
      this.sendDestinationPortAgent(instructionRuleJson.pushLink || '17', instructionRuleJson.mailTemplateUuid || '', instructionParamJson.ruleName || '', instruction.tenantInstructionUuid || '', instructionParamJson.fileTypeOfTakeMulti || '')
    },
    async sendDestinationPortAgent(pushLink, mailTemplateUuid = '', ruleName = '', instructionUuid = '', fileTypeOfTakeMulti = '') {
      const loading = getLoading4Cxt(this)
      try {
        const res = await checkSendDestinationPortAgent({
          checkNode: ruleName ? CheckRuleConstants.OPERATION_INSTRUCTION_VALID.code : CheckRuleConstants.NODE_SEND_DESTINATION_AGENT_EMAIL.code,
          lob: this.job.lob,
          seJob: this.job._data || this.job,
          pushLink,
          mailTemplateUuid,
          exchangeAgent: pushLink === '17' && this.exchangeAgentSelectDialog.selectData ? this.exchangeAgentSelectDialog.selectData.exchangeAgent : 0,
          ruleName
        })
        const { isPass, master, slave, list, isContinue } = res.data
        let masterInfo = ''
        if (master.length > 0) {
          const masterFileInfo = Array.from(master, p => (this.fileTypeCapsMap.get(p) || p) + this.$t('Message.File')).join(', ')
          masterInfo = this.$t('Message.MasterCheckExist', [masterFileInfo])
        }
        let slaveInfo = ''
        if (slave.length > 0) {
          const slaveFileInfo = Array.from(slave, p => (this.fileTypeCapsMap.get(p) || p) + this.$t('Message.File')).join(', ')
          slaveInfo = this.$t('Message.SmallCheckExist', [slaveFileInfo])
        }
        for (const item of list) {
          if (item.info === 'CUSTOMERSELFRELEASE' || item.info === 'CUSTOMERSELFRELEASE_DRAFT') {
            item.info = this.$t('SeaExport.CustomerSelfIssuedFiles')
          }
          if (item.manifestEqualContainerNumCheck) {
            if (item.isExist) {
              item.info = this.$t('Message.ManifestFileNumBox')
            } else {
              item.info = this.$t('Message.ManifestFileNumNotEqualBox', [item.containerCount, item.fileNameCount])
            }
          } else {
            if (item.isExist) {
              const index = item.info.lastIndexOf('.')
              if (index > -1) {
                item.fileType = item.info.substring(index + 1)
                item.info = item.info.substring(0, index)
              }
            } else {
              item.info = this.$t('Message.Lack') + ' ' + (this.fileTypeCapsMap.get(item.info) || item.info)
            }
          }
        }
        this.checkingWindow.isPass = isPass
        this.checkingWindow.masterInfo = masterInfo
        this.checkingWindow.slaveInfo = slaveInfo
        this.checkingWindow.rowData = list
        this.checkingWindow.showNext = isContinue
        this.checkingWindow.pushLink = pushLink
        this.checkingWindow.mailTemplateUuid = mailTemplateUuid
        this.checkingWindow.instructionUuid = instructionUuid
        this.checkingWindow.fileTypeOfTakeMulti = fileTypeOfTakeMulti
        this.checkingWindow.mailTemplateInterfaceType = 1
        this.checkingWindow.visible = true
      } finally {
        loading.close()
      }
    },
    async sendDestinationPortAgentNext() {
      const rows = this.gridApi.getSelectedRows()
      this.sendDestinationPortAgentEmailDialog.fileList = Array.from(rows, p => ({ fileId: p.fileId, fileName: p.fileName, createDate: p.createDate }))
      this.sendDestinationPortAgentEmailDialog.pushLink = this.checkingWindow.pushLink
      this.sendDestinationPortAgentEmailDialog.mailTemplateUuid = this.checkingWindow.mailTemplateUuid
      this.sendDestinationPortAgentEmailDialog.fileTypeOfTakeMulti = this.checkingWindow.fileTypeOfTakeMulti
      if (this.checkingWindow.pushLink === '17') {
        this.sendDestinationPortAgentEmailDialog.exchangeAgentData = this.exchangeAgentSelectDialog.selectData
      } else {
        this.sendDestinationPortAgentEmailDialog.exchangeAgentData = null
      }
      this.sendDestinationPortAgentEmailDialog.mailTemplateInterfaceType = this.checkingWindow.mailTemplateInterfaceType
      this.sendDestinationPortAgentEmailDialog.visible = true
    },
    sendDestinationPortAgentCallback(data) {
      const newJob = {
        sentDestinationPortAgent: data.sentDestinationPortAgent,
        sentDestinationPortAgentDate: data.sentDestinationPortAgentDate,
        version: data.version
      }
      Object.assign(this.job, newJob)
      this.$emit('writebackJob', newJob)
    },
    resetOneClickSend(instructionUuid = '') {
      const loading = getLoading4Cxt(this)
      resetOneClickSend(this.job.uuid).then(res => {
        loading.close()
        const newJob = {
          sentDestinationPortAgent: res.data.sentDestinationPortAgent,
          sentDestinationPortAgentDate: res.data.sentDestinationPortAgentDate,
          version: res.data.version
        }
        Object.assign(this.job, newJob)
        this.$emit('writebackJob', newJob)
        this.instructionCallback({ jobUuids: [this.job.uuid], executeStatus: true, instructionUuid })
      }).catch(() => {
        loading.close()
      })
    },
    onInstructionClick(item) {
      if (item.platformInstructionRuleCode === this.UPLOAD_FILE.code) {
        this.$refs.uploadFileWindow.onShowOfUI(item, this.job)
      } else {
        this.$refs.oneClickSendWindow.onShowOfUI(item, this.job, this.gridApi.getSelectedRows())
      }
    },
    // 【委托拼箱】发送目的港代理校验
    async showCheckingSendDestinationAgentWindow(item) {
      const loading = getLoading4Cxt(this)
      try {
        const res = await checkSendDestinationPortAgentMulti({
          mailTemplateUuid: item.instructionRuleJson.mailTemplateUuid,
          pushLink: item.instructionRuleJson.pushLink,
          branchId: this.$store.getters.currentOfficeId,
          lob: this.job.lob,
          jobUuids: [this.job.uuid],
          trackingCode: '',
          tenantInstructionUuid: item.tenantInstructionUuid,
          ruleName: item.instructionParamJson.ruleName
        })
        const { isPass, list, isContinue } = res.data
        for (const item of list) {
          if (item.info === 'CUSTOMERSELFRELEASE' || item.info === 'CUSTOMERSELFRELEASE_DRAFT') {
            item.info = this.$t('SeaExport.CustomerSelfIssuedFiles')
          }
          if (item.manifestEqualContainerNumCheck) {
            if (item.isExist) {
              item.info = this.$t('Message.ManifestFileNumBox')
            } else {
              item.info = this.$t('Message.ManifestFileNumNotEqualBox', [item.containerCount, item.fileNameCount])
            }
          } else {
            if (item.isExist) {
              const index = item.info.lastIndexOf('.')
              if (index > -1) {
                item.fileType = item.info.substring(index + 1)
                item.info = item.info.substring(0, index)
              }
            } else {
              item.info = this.$t('Message.Lack') + ' ' + (this.fileTypeCapsMap.get(item.info) || item.info)
            }
          }
        }
        this.checkingWindow.isPass = isPass
        this.checkingWindow.masterInfo = ''
        this.checkingWindow.slaveInfo = ''
        this.checkingWindow.rowData = list
        this.checkingWindow.showNext = isContinue
        this.checkingWindow.pushLink = item.instructionRuleJson.pushLink
        this.checkingWindow.instructionUuid = item.tenantInstructionUuid
        this.checkingWindow.fileTypeOfTakeMulti = item.instructionParamJson.fileTypeOfTakeMulti
        this.checkingWindow.mailTemplateInterfaceType = 2
        this.checkingWindow.visible = true
      } finally {
        loading.close()
      }
    },
    async instructionCallback(data) {
      if (data.instructionUuid) {
        const loading = getLoading4Cxt(this)
        await generateInstructionRecord(data).finally(() => {
          loading.close()
        })
      }
      this.loadInstructionBtns()
    },
    onWritebackJob(data) {
      this.$emit('writebackJob', data)
    },
    onInstructionCallback() {
      this.loadInstructionBtns()
    }
  }
}
</script>

<style lang="scss" scoped>
</style>
